// *
// example
// Before: /calls/engineering_networks/mycalls/22739
// After: /calls/engineering_networks/mycalls
//
// Отрежет только айдишник на который заканчивается урл:
//
// Before: /calls/123123engineering_networks/mycalls/22739
// After: /calls/123123engineering_networks/mycalls
//
// Before: /calls/engineering_networks/mycalls/22739/222
// After: /calls/engineering_networks/mycalls/22739
// *

export const getBasePath = pathname => {
  const RegExpToBaseUrl = new RegExp(/\/\d{1,}$/);
  return pathname.replace(RegExpToBaseUrl, '');
};
